"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "payments_cont" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["value"];
const _hoisted_4 = {
    key: 0,
    class: "card-warning"
};
const _hoisted_5 = {
    key: 1,
    class: "card-warning"
};
const _hoisted_6 = {
    key: 2,
    class: "card-warning"
};
const _hoisted_7 = { class: "payments_title" };
const _hoisted_8 = {
    key: 1,
    class: "card-warning"
};
const _hoisted_9 = {
    key: 0,
    class: "tm-warning"
};
const _hoisted_10 = { class: "label label-error" };
const _hoisted_11 = {
    key: 1,
    class: "payments_save"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Card = (0, vue_1.resolveComponent)("Card");
    const _component_warnings_component = (0, vue_1.resolveComponent)("warnings-component");
    const _component_payment_unit_component = (0, vue_1.resolveComponent)("payment-unit-component");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    const _directive_trim_whitespace = (0, vue_1.resolveDirective)("trim-whitespace");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.showtitle === true)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.playerinput.title)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.cards, (availableCard) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("label", {
                class: "payments_cards",
                key: availableCard.name
            }, [
                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                    class: "hidden",
                    type: "radio",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.cardName) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.cardChanged())),
                    value: availableCard.name
                }, null, 40, _hoisted_3), [
                    [vue_1.vModelRadio, _ctx.cardName]
                ]),
                (0, vue_1.createVNode)(_component_Card, {
                    class: "cardbox",
                    card: availableCard
                }, null, 8, ["card"])
            ]));
        }), 128)),
        (_ctx.card.additionalProjectCosts)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 1 }, [
                (_ctx.card.additionalProjectCosts.aeronGenomicsResources)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_4, [...(_cache[2] || (_cache[2] = [
                            (0, vue_1.createTextVNode)(" Playing ${0} consumes ${1} ${2} from ${3} ", -1)
                        ]))])), [
                        [_directive_i18n, [_ctx.$t(_ctx.card.name), _ctx.card.additionalProjectCosts.aeronGenomicsResources, 'animals', _ctx.$t(_ctx.CardName.AERON_GENOMICS)]]
                    ])
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.card.additionalProjectCosts.thinkTankResources)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                            (0, vue_1.createTextVNode)(" Playing ${0} consumes ${1} ${2} from ${3} ", -1)
                        ]))])), [
                        [_directive_i18n, [_ctx.$t(_ctx.card.name), _ctx.card.additionalProjectCosts.thinkTankResources, 'data', _ctx.$t(_ctx.CardName.THINK_TANK)]]
                    ])
                    : (0, vue_1.createCommentVNode)("", true),
                (_ctx.card.additionalProjectCosts.redsCost)
                    ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_6, [...(_cache[4] || (_cache[4] = [
                            (0, vue_1.createTextVNode)(" Playing ${0} will cost ${1} M€ more because ${2} are in power ", -1)
                        ]))])), [
                        [_directive_i18n, [_ctx.$t(_ctx.card.name), _ctx.card.additionalProjectCosts.redsCost, _ctx.$t('Reds')]]
                    ])
                    : (0, vue_1.createCommentVNode)("", true)
            ], 64))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createVNode)(_component_warnings_component, {
            warnings: _ctx.card.warnings
        }, null, 8, ["warnings"]),
        (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("section", null, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h3", _hoisted_7, [...(_cache[5] || (_cache[5] = [
                    (0, vue_1.createTextVNode)("How to pay?", -1)
                ]))])), [
                [_directive_i18n]
            ]),
            ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.SPENDABLE_RESOURCES, (unit) => {
                return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", { key: unit }, [
                    (_ctx.canUse(unit) === true)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_payment_unit_component, {
                            key: 0,
                            modelValue: _ctx.payment[unit],
                            "onUpdate:modelValue": ($event) => ((_ctx.payment[unit]) = $event),
                            modelModifiers: { number: true },
                            unit: unit,
                            description: _ctx.descriptions[unit],
                            onPlus: ($event) => (_ctx.addValue(unit)),
                            onMinus: ($event) => (_ctx.reduceValue(unit)),
                            onMax: ($event) => (_ctx.setMaxValue(unit))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "unit", "description", "onPlus", "onMinus", "onMax"]))
                        : (0, vue_1.createCommentVNode)("", true),
                    (_ctx.showReserveWarning(unit))
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_8, [...(_cache[6] || (_cache[6] = [
                                (0, vue_1.createTextVNode)(" (Some ${0} are unavailable here in reserve for the project card.) ", -1)
                            ]))])), [
                            [_directive_i18n, _ctx.$t(unit)]
                        ])
                        : (0, vue_1.createCommentVNode)("", true)
                ]));
            }), 128)),
            (_ctx.hasWarning())
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_9, [
                    (0, vue_1.createElementVNode)("label", _hoisted_10, (0, vue_1.toDisplayString)(_ctx.$t(_ctx.warning)), 1)
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.showsave === true)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_11, [
                    (0, vue_1.createVNode)(_component_AppButton, {
                        size: "big",
                        onClick: _ctx.saveData,
                        title: _ctx.$t(_ctx.playerinput.buttonLabel),
                        "data-test": "save"
                    }, null, 8, ["onClick", "title"])
                ]))
                : (0, vue_1.createCommentVNode)("", true)
        ])), [
            [_directive_trim_whitespace]
        ])
    ]));
}
